import { render, staticRenderFns } from "./HrPoliciesForm.vue?vue&type=template&id=5bdcc4b7&"
import script from "./HrPoliciesForm.vue?vue&type=script&lang=js&"
export * from "./HrPoliciesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports